var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileSlash = function SvgFileSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.443 4.458a.805.805 0 0 0-.991 1.266l19.828 15.54A.805.805 0 0 0 23.271 20l-3.979-3.119V9.462c0-.57-.224-1.116-.626-1.518l-3.034-3.03a2.14 2.14 0 0 0-1.514-.627H8.574A2.146 2.146 0 0 0 6.431 6.43V6.8zm4.596 3.6V6.43c0-.294.24-.535.535-.535h5.36v2.679a1.07 1.07 0 0 0 1.071 1.072h2.68v5.975zm10.778 12.58-1.263-.994a.53.53 0 0 1-.405.184H8.574a.54.54 0 0 1-.535-.536v-7.144L6.43 10.882v8.41c0 1.182.961 2.144 2.143 2.144h8.575a2.14 2.14 0 0 0 1.668-.798"
  })));
};
export default SvgFileSlash;